import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.559 2.75a.612.612 0 1 1 0 1.222H1.222v9.472h9.472V7.101a.61.61 0 0 1 .61-.61l.061.001a.613.613 0 0 1 .551.609v6.417a1.15 1.15 0 0 1-1.148 1.148H1.143A1.15 1.15 0 0 1 0 13.518V3.893A1.144 1.144 0 0 1 1.143 2.75zM14.208 0a.464.464 0 0 1 .458.458v4.81a.452.452 0 0 1-.775.324l-2.011-1.98-5.794 5.7a.612.612 0 0 1-1.04-.442c0-.161.065-.316.179-.43L11 2.755 8.995.78a.45.45 0 0 1-.098-.494A.45.45 0 0 1 9.32 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }